

import { ResponsiveContainer, ComposedChart, CartesianGrid, YAxis, Tooltip, Area } from "recharts";
import { useTheme } from "@mui/material";

interface ComponentGraphProps {
    chartData: any[];
}

export const ComponentGraph: React.FC<ComponentGraphProps> = ({ chartData }) => {

    const theme = useTheme();

    return (
        <ResponsiveContainer width="100%" height={150}>
            <ComposedChart
                data={chartData} margin={{ top: 8, right: 0, bottom: 8, left: 0 }}>


                <CartesianGrid strokeDasharray="0 0" stroke={theme.palette.divider} vertical={false} />

                <YAxis
                    interval={1}
                    yAxisId="right"
                    orientation="right"
                    domain={[0, 2]}
                    hide={true}
                />

                <Tooltip />

                <Area
                    yAxisId="right"
                    type='monotone'
                    dataKey="forecast"
                    name="Trend"
                    stroke={theme.palette.primary.main}
                    strokeWidth={3}
                    fill="url(#splitColor)"
                    dot={false}
                    isAnimationActive={false}
                />

                <defs>
                    <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0" stopColor={theme.palette.primary.main} stopOpacity={0.2} />
                        <stop offset="1" stopColor={theme.palette.primary.main} stopOpacity={0.1} />
                    </linearGradient>
                </defs>
            </ComposedChart>
        </ResponsiveContainer>
    );
};